document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth > 767) return;
  
  function overrideCloseDrawer() {
    const facetsDrawer = document.querySelector('facets-drawer');
    if (facetsDrawer && typeof facetsDrawer.closeDrawer === 'function') {
      facetsDrawer.closeDrawer = function() {
        const drawer = document.querySelector("#facets-content-filter");
        if (!drawer) return;
        
        drawer.classList.remove("is-visible");
        
        setTimeout(() => {
          document.body.classList.remove("overflow-hidden");
        }, 300);
      };
    }
  }
  
  setTimeout(overrideCloseDrawer, 1000);

  /* Add Temizle link into the sticky footer alongside the existing Uygula button */
  function enhanceFooter() {
    const drawer = document.querySelector('#facets-content-filter');
    if (!drawer) return;
    const footer = drawer.querySelector('.hp-filter-footer');
    if (!footer) return;
    // Only add once
    if (footer.querySelector('.hp-mobile-clear-btn')) return;

    const clearLink = document.createElement('a');
    clearLink.className = 'hp-mobile-clear-btn';
    clearLink.href = '#';
    clearLink.textContent = 'Temizle';
    clearLink.style.cssText = 'display:flex;align-items:center;justify-content:center;width:40%;height:44px;background:transparent;color:#000;font-size:13px;font-weight:500;letter-spacing:0.04em;text-decoration:underline;text-underline-offset:2px;border:none;cursor:pointer;flex-shrink:0;';
    clearLink.addEventListener('click', function(e) {
      e.preventDefault();
      // Uncheck all checkboxes in the filter form
      var form = drawer.querySelector('#filter-facets-form');
      if (form) {
        form.querySelectorAll('input[type="checkbox"]:checked').forEach(function(cb) {
          cb.checked = false;
        });
        form.querySelectorAll('input[type="number"]').forEach(function(inp) {
          inp.value = '';
        });
        // Trigger submit
        var event = new CustomEvent('input');
        form.dispatchEvent(event);
      }
    });

    footer.insertBefore(clearLink, footer.firstChild);
  }

  // Run immediately and on drawer open
  setTimeout(enhanceFooter, 500);

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const drawer = mutation.target;
        if (drawer.classList.contains('is-visible')) {
          setTimeout(enhanceFooter, 100);
        }
      }
    });
  });
  
  const drawer = document.querySelector('#facets-content-filter');
  if (drawer) {
    observer.observe(drawer, { attributes: true });
  }
});

function applyMobileFilters() {
  const drawer = document.querySelector('#facets-content-filter');
  if (drawer) {
    drawer.classList.remove('is-visible');
    
    setTimeout(() => {
      document.body.classList.remove('overflow-hidden');
      
      const form = drawer?.querySelector('form');
      if (form) {
        form.submit();
      }
    }, 300);
  }
}
